import React, { useState } from "react";

import * as Styled from "./CopyButton.styles";

interface Props {
  copyText: string;
}

export default function CopyButton({ copyText }: Props) {
  const [showCopied, setShowCopied] = useState(false);

  const copyToClipboard = () => {
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
    navigator.clipboard.writeText(copyText);
  };

  return (
    <Styled.CopyButtonContainer>
      <Styled.CopyButton onClick={copyToClipboard}>{showCopied ? "Copied" : "Copy"}</Styled.CopyButton>
    </Styled.CopyButtonContainer>
  );
}
